export default function StockRequestPage() {
  return (
    <div data-workspace-redundant-header><div className="space-y-4">
      <h1 className="text-2xl font-semibold">Stock Request</h1></div>
      <div className="rounded-lg border bg-white p-6">
        <p className="font-medium">Permintaan Stok</p>
        <p className="mt-2 text-sm text-slate-500">
          Halaman permintaan dan pemenuhan stok akan dikembangkan pada tahap berikutnya.
        </p>
      </div>
    </div>
  );
}
